export { default } from "./MemoModal";
export { default as MemoModal } from "./MemoModal";
